import { useMutation } from '@tanstack/react-query';
import type { TypeCreateLaborAccountsMeRequest, TypeCreateLaborAccountsMeResponse } from '~/api/laborAccounts';
import { registerMockAPI } from '~/mocks/mockApis';

import { axiosInstance } from '~/services/fetchServiceV2';
import { TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

/** @description 회원 생년월일/성별 캐시 저장 커스텀 훅 */
export const useSaveMemberPrivacyInfo = () => {
  const { mutateAsync } = useMutation({
    mutationFn: (params: TypeCreateLaborAccountsMeRequest) => {
      return axiosInstance.post<TypeCreateLaborAccountsMeResponse>('/labor-accounts/me', params);
    },
  });

  const requestSaveMemberPrivacyInfo = ({
    params,
    onSuccess,
    onError,
  }: {
    params: TypeCreateLaborAccountsMeRequest;
    onSuccess?: (res: TypeCreateLaborAccountsMeResponse) => void;
    onError?: (err: TypeErrorFormat) => void;
  }) => {
    requestHelper(() => mutateAsync(params), onSuccess, onError);
  };

  return requestSaveMemberPrivacyInfo;
};

registerMockAPI<TypeCreateLaborAccountsMeResponse>({
  method: 'post',
  endpoint: '/labor-accounts/me',
  label: '근무 지원 정보/회원 생년월일, 성별 캐시 저장',
  scenarios: [
    {
      name: '저장 성공',
      response: {
        code: '0000',
        message: '성공',
      },
    },
  ],
});
